/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_scatter_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What input formats are accepted?`)
};

const es_scatter_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué formatos de entrada se aceptan?`)
};

const de_scatter_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welche Eingabeformate werden akzeptiert?`)
};

const nl_scatter_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welke invoerformaten worden geaccepteerd?`)
};

const fr_scatter_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quels formats d'entrée sont acceptés ?`)
};

const it_scatter_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quali formati di input sono accettati?`)
};

const pt_br2_scatter_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quais formatos de entrada são aceitos?`)
};

const pt_scatter_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que formatos de entrada são aceites?`)
};

const ja_scatter_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`どのような入力形式に対応していますか？`)
};

const zh_scatter_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`接受哪些输入格式？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const scatter_faq_q3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.scatter_faq_q3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("scatter_faq_q3", locale)
	if (locale === "en") return en_scatter_faq_q3(inputs)
	if (locale === "es") return es_scatter_faq_q3(inputs)
	if (locale === "de") return de_scatter_faq_q3(inputs)
	if (locale === "nl") return nl_scatter_faq_q3(inputs)
	if (locale === "fr") return fr_scatter_faq_q3(inputs)
	if (locale === "it") return it_scatter_faq_q3(inputs)
	if (locale === "pt-BR") return pt_br2_scatter_faq_q3(inputs)
	if (locale === "pt") return pt_scatter_faq_q3(inputs)
	if (locale === "ja") return ja_scatter_faq_q3(inputs)
	return zh_scatter_faq_q3(inputs)
};